export default "__VITE_ASSET__B8uH0XjF__"